import {TwilioService} from '@app/modules/wrtc/services/providers/twilio/twilio.service';
import {Store} from '@ngxs/store';
import {JsonLogService} from '@app/modules/shared/services/json-log.service';
import {UsersListService} from '@app/modules/shared/services/users-list.service';
import {UserDisconnectionHandlerService} from '@app/modules/shared/services/user-disconnection-handler.service';
import {HttpClient} from '@angular/common/http';

export function wrtcProviderFactory(store: Store,
                                    jsonLogService: JsonLogService,
                                    usersListService: UsersListService,
                                    userDisconnectionHandlerService: UserDisconnectionHandlerService,
                                    httpClient: HttpClient) {
    return new TwilioService(store, jsonLogService, usersListService, userDisconnectionHandlerService, httpClient);
    // return new OpentokService();
}
